export default __webpack_public_path__ + "static/media/coupon.e4985d11.png";